// extracted by mini-css-extract-plugin
export default {"joinLink":"joinLink___aMIY3"};